import React, { createContext, useContext, useEffect, useState } from 'react';
import './index.css';
import logo from './assets/DownloadingFilled.png';
import { LoadingSpinner } from 'pepsico-ds';
const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);

    const showLoader = () => setIsLoading(true);
    const hideLoader = () => {
        setTimeout(() => {
            setIsLoading(false)
        }, 100);
    };

    useEffect(() => {
        if (isLoading) {
            document.body.classList.add('loading');
        } else {
            document.body.classList.remove('loading');
        }
    }, [isLoading]);

    return (
        <LoadingContext.Provider value={{ isLoading, showLoader, hideLoader }}>
            {children}
            {isLoading && <GlobalLoader />}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);

const GlobalLoader = () => (
    <div
        style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
        }}
    >
        {/* <div
            style={{
                width: '50px', // Set dimensions
                height: '50px',
                backgroundImage: `url(${logo})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
            }}
        />
    </div> */}
                    <LoadingSpinner
                className=""
                size={{
                    height: '50px',
                    width: '50px'
                }}
                style={{}}
                />
                </div>
);
